/**
 * 工序演示视频（/process-demo/:name）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 * 参考 src/pages/ganzi/product-research.vue 与 src/cms/fields/productResearch.js 的迁移方式。
 */
import { STEP_KEYS, PROCESS_STEPS } from '@/data/processFlow'

// 逐工序视频：每行一个工序，填「视频地址」即替换该工序演示视频；留空则用页面内置占位片源。
// key / name 仅用于定位与显示，请勿修改。
const STEP_VIDEOS = PROCESS_STEPS.map(s => ({ key: s.key, name: s.name, video: '' }))

export default {
  title: '工序演示视频',
  groups: [
    {
      title: '页头与说明',
      fields: [
        { key: 'back', label: '返回按钮文字', type: 'text', default: '返回工艺流程' },
        { key: 'demoBadge', label: '演示视频角标前缀', type: 'text', default: '生产演示视频' },
        { key: 'panelTitle', label: '右侧面板标题', type: 'text', default: '工序要点' },
        { key: 'note', label: '底部说明文字', type: 'textarea', default: '演示视频为框架期占位片源，接入实际工位摄像机位后按工序替换视频地址即可。' },
      ],
    },
    {
      title: '工序要点数据（按工序 key → 要点列表）',
      fields: [
        { key: 'stepKeys', label: '各工序要点补充信息', type: 'object', default: STEP_KEYS },
      ],
    },
    {
      title: '逐工序演示视频（按工序填写，留空用页面内置）',
      fields: [
        { key: 'stepVideos', label: '各工序视频（key/name 勿改，video 列可直接本地上传或从素材库选择）', type: 'array', default: STEP_VIDEOS },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认渐变）', type: 'image', default: '' },
      ],
    },
  ],
}
